<template>
    <div>
        <Pane title="重新提交蓝图替换" :showRemarks="false">
            <template>重新发起蓝图替换流程</template>
        </Pane>

        <div class="add-form">
            <a-skeleton :loading="loading" :paragraph="{ rows: 8 }">
                <a-form layout="horizontal" :colon="false" label-align="right" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
                    <div class="title" style="margin-top: 0">基础信息</div>
                    <div class="wrapper">
                        <a-row :gutter="16" style="margin-bottom: 12px; background: #f9f9f9; margin: 0 auto; padding: 12px;">
                            <a-col :span="24">
                                <a-form-item label="工程名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
                                    <a-input v-model="form.projectName" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计编号">
                                    <a-input v-model="form.designNo" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="设计阶段">
                                    <a-input v-model="form.phaseName" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="专业">
                                    <a-input v-model="form.majorName" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="成果名称">
                                    <a-input v-model="form.resultName" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="成果编号">
                                    <a-input v-model="form.resultNo" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="子项">
                                    <a-input v-model="form.subName" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="申请人">
                                    <a-input v-model="form.applicantName" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="申请阶段">
                                    <a-input v-model="form.applyStage" readonly />
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="图审通过时间">
                                    <a-input v-model="form.auditPassTime" readonly />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="title">文件列表</div>
                    <div class="wrapper">
                        <a-row :gutter="16" style="margin-bottom: 12px; background: #f9f9f9; margin: 0 auto; padding: 12px;">
                            <div v-if="fileList.length === 0" style="text-align: center; padding: 20px; color: #999;">
                                暂无文件
                            </div>
                            <a-table v-else bordered :dataSource="fileList" :pagination="false">
                                <a-table-column title="原文件名" width="auto">
                                    <template slot-scope="text, record">
                                        {{ record.oldFile ? record.oldFile.name : '' }}
                                    </template>
                                </a-table-column>
                                <a-table-column title="替换文件" width="auto">
                                    <template slot-scope="text, record">
                                        <template v-if="record.uploading">
                                            <a-progress :percent="record.uploadProgress" :show-info="true" />
                                        </template>
                                        <template v-else>
                                            {{ record.newFile ? record.newFile.name : '' }}
                                        </template>
                                    </template>
                                </a-table-column>
                                <a-table-column title="替换文件类型" width="140">
                                    <template slot-scope="text, record, index">
                                        <template v-if="record.newFile">
                                            <a-select v-model="record.type" style="width: 130px" placeholder="请选择替换文件类型" @change="(val) => handleFileTypeChange(val, index)">
                                                <a-select-option v-for="opt in attachmentTypeOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</a-select-option>
                                            </a-select>
                                        </template>
                                        <template v-else>
                                            {{ typeLabel(record.oldFile.type) }}
                                        </template>
                                    </template>
                                </a-table-column>
                                <a-table-column title="替换是否签章" width="100">
                                    <template slot-scope="text, record">
                                        <template v-if="record.newFile">
                                            <a-switch v-model="record.isSign" />
                                        </template>
                                        <template v-else>
                                            {{ record.oldFile.isSign ? '是' : '否' }}
                                        </template>
                                    </template>
                                </a-table-column>
                                <a-table-column title="操作" align="center" width="120">
                                    <template slot-scope="text, record, index">
                                        <a-button type="link" icon="upload" @click="triggerUpload(index)">{{ record.newFile ? '重新上传' : '上传' }}</a-button>
                                    </template>
                                </a-table-column>
                            </a-table>
                            <input ref="fileInput" type="file" style="display:none" @change="onFileSelected" />
                        </a-row>
                    </div>

                    <div class="title">补充说明</div>
                    <div class="wrapper">
                        <a-row :gutter="16" style="margin-bottom: 12px; background: #f9f9f9; margin: 0 auto; padding: 12px;">
                            <a-col :span="24">
                                <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }" label="替换原因">
                                    <a-textarea v-model="form.replaceRemark" :rows="4" placeholder="请输入替换原因" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import OSS from 'ali-oss'
import { fetchReplaceDetail, resubmitReplaceResult } from "@/api/project-execute/result";
import { mapMutations, mapState } from "vuex";
import { getUploadFileskey } from '@/api/upload'

export default {
    name: "BlueprintReplaceReapply",
    components: {},
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            taskId: "",
            instanceId: "",
            form: {
                projectName: '',
                designNo: '',
                phaseName: '',
                phaseCode: '',
                majorName: '',
                resultName: '',
                resultNo: '',
                subName: '',
                applicantName: '',
                applyStage: '',
                auditPassTime: '',
                replaceRemark: ''
            },
            fileList: [],
            uploadIndex: -1,
            attachmentTypeOptions: [
                { value: 'calc', label: '计算书' },
                { value: 'spec', label: '说明书' },
                { value: 'blueprint', label: '图纸' },
                { value: 'text', label: '文本' }
            ],
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                // businessKey 格式：id:1517214225298165760,DesignResultReplace:1516856236972249088
                // 提取第一个 id
                const parts = businessKey.split(',');
                if (parts.length > 0) {
                    const firstPart = parts[0];
                    const idParts = firstPart.split(':');
                    this.id = idParts.length > 1 ? idParts[1] : '';
                }
            }
        }

        if (this.id) {
            this.fetchDetail(this.id);
        }
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        triggerUpload(index) {
            this.uploadIndex = index
            this.$refs.fileInput.click()
        },
        async onFileSelected(e) {
            const file = e.target.files[0]
            if (!file) return
            const index = this.uploadIndex
            if (index < 0) return
            this.$set(this.fileList[index], 'uploading', true)
            this.$set(this.fileList[index], 'uploadProgress', 0)
            try {
                const tokenInfo = await getUploadFileskey([file.name])
                const relativePath = tokenInfo[file.name]
                if (!relativePath) {
                    this.$message.error('获取上传路径失败')
                    return
                }
                const region = tokenInfo.region.startsWith('oss-') ? tokenInfo.region : `oss-${tokenInfo.region}`
                const client = new OSS({
                    region,
                    accessKeyId: tokenInfo.accessKeyId,
                    accessKeySecret: tokenInfo.accessKeySecret,
                    stsToken: tokenInfo.securityToken,
                    bucket: tokenInfo.bucket,
                })
                await client.put(relativePath, file, {
                    progress: (p) => {
                        this.fileList[index].uploadProgress = Math.round(p * 100)
                    }
                })
                let signedUrl
                try {
                    signedUrl = client.signatureUrl(relativePath, {
                        expires: 3600,
                        method: 'GET'
                    })
                } catch (signError) {
                    console.warn('使用 STS 凭证生成签名失败:', signError)
                }
                this.$set(this.fileList[index], 'newFile', {
                    id: '',
                    name: file.name,
                    size: file.size ? file.size.toString() : '',
                    relativePath: relativePath,
                    url: signedUrl,
                    bucket: tokenInfo.bucket,
                    region: region,
                    objectKey: relativePath
                })
            } catch (error) {
                console.error('上传失败:', error)
                this.$message.error('文件上传失败')
            } finally {
                this.$set(this.fileList[index], 'uploading', false)
            }
            e.target.value = null
        },
        typeLabel(val) {
            const found = this.attachmentTypeOptions.find(o => o.value === val)
            return found ? found.label : ''
        },
        handleFileTypeChange(val, index) {
            if (val === 'blueprint') {
                this.$set(this.fileList[index], 'isSign', true)
            }
        },
        fetchDetail(id) {
            this.loading = true;
            fetchReplaceDetail(id)
                .then((data) => {
                    if (!data) return;

                    // 设置表单数据
                    this.form = {
                        projectName: data.projectName || '',
                        designNo: data.designNo || '',
                        phaseName: data.phaseName || data.phaseCode || '',
                        phaseCode: data.phaseCode || '',
                        phaseId:data.phaseId || '',
                        majorCode:data.majorCode || '',
                        majorName: data.majorName || '',
                        resultName: data.resultName || '',
                        resultNo: data.resultNo || '',
                        subName: data.subName || '',
                        applicantName: data.applicantName || '',
                        applyStage: data.applyStage || '',
                        auditPassTime: data.auditPassTime || '',
                        replaceRemark: data.replaceRemark || '',
                        businessType:data.businessType || '',
                        businessId:data.businessId || '',
                        subCode:data.subCode||'',

                    };

                    // 处理文件列表
                    const oldFiles = data.oldFiles || [];
                    const newFiles = data.newFiles || [];

                    // 创建文件列表，每个原文件对应一个新文件
                    this.fileList = oldFiles.map((oldFile, index) => ({
                        oldFile: {
                            id: oldFile.id || '',
                            name: oldFile.name || '',
                            type: oldFile.type || '',
                            isSign: oldFile.isSign || false
                        },
                        newFile: newFiles[index] ? {
                            id: newFiles[index].id || '',
                            name: newFiles[index].name || '',
                            size: newFiles[index].size || '',
                            relativePath: newFiles[index].relativePath || '',
                        } : null,
                        type: oldFile.type || '',
                        isSign: oldFile.isSign || false
                    }));
                })
                .catch(() => {
                    this.$message.error("获取替换详情失败");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        submitReview() {
            if (!this.form.replaceRemark) {
                this.$message.warning('请输入替换原因');
                return;
            }

            const oldFiles = this.fileList
                .filter(item => item.oldFile)
                .map(item => ({
                    id: item.oldFile.id,
                    name: item.oldFile.name,
                    type: item.oldFile.type || '',
                    isSign: item.oldFile.isSign || false
                }));

            const newFiles = this.fileList
                .filter(item => item.newFile)
                .map(item => ({
                    id: item.newFile.id,
                    name: item.newFile.name,
                    size: item.newFile.size,
                    relativePath: item.newFile.relativePath,
                    type: item.type || '',
                    isSign: item.isSign || false
                }));

            if (newFiles.length === 0) {
                this.$message.warning('请至少上传一个替换文件');
                return;
            }
            for (let i = 0; i < this.fileList.length; i++) {
                if (this.fileList[i].newFile && !this.fileList[i].type) {
                    this.$message.warning(`替换文件类型为必填项，第 ${i + 1} 行尚未选择`)
                    return
                }
            }

            this.submitting = true;
            const params = {
                id: this.id,
                projectName: this.form.projectName,
                designNo: this.form.designNo,
                phaseName: this.form.phaseName,
                phaseCode: this.form.phaseCode,
                majorName: this.form.majorName,
                resultName: this.form.resultName,
                resultNo: this.form.resultNo,
                subName: this.form.subName,
                applicantName: this.form.applicantName,
                applyStage: this.form.applyStage,
                auditPassTime: this.form.auditPassTime,
                replaceRemark: this.form.replaceRemark,

                businessType:this.form.businessType || '',
                businessId:this.form.businessId || '',
                subCode:this.form.subCode||'',
                oldFiles: oldFiles,
                newFiles: newFiles
            };

            resubmitReplaceResult(params)
                .then(() => {
                    this.$close(this.$route.path, "/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    // this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.add-form {
    background-color: #fff;
    padding: 24px;
}

.title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin: 16px 0;
    padding-left: 8px;
    border-left: 3px solid #1890ff;
}

.wrapper {
    margin-bottom: 16px;
}

.center {
    margin-top: 24px;
    display: flex;
    justify-content: center;
}
</style>
